module.exports = __webpack_public_path__ + "img/ae-gif-6.4b23fed.gif";